import React, { useEffect } from 'react';
import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { Link } from '@perch-labs/shrike';
import { routes } from 'config';
import type { MappedContractSubscriberRequirement } from 'hooks/use-contract-requirements.hook';
import { useUser } from 'hooks/use-user.hook';
import {
  getTermLinkJoiner,
  getTermsUrl,
  dynamicLanguageParam,
} from './term-link.utils';

interface Props {
  contractVersion: MappedContractSubscriberRequirement;
  index: number;
  numberOfContracts: number;
}

export const TermLink = ({
  contractVersion,
  index,
  numberOfContracts,
}: Props) => {
  const { data: user } = useUser();
  const ldClient = useLDClient();

  useEffect(() => {
    // @ts-expect-error Property 'kind' is missing
    // flag evaluates incorrectly if you add that -\_(o.o)_/-
    ldClient?.identify({
      key: user?.id?.toString(),
      custom: { state: contractVersion.stateAbbreviation?.toLowerCase() },
    });
  }, []);

  const { csEnablePersonalizedContracts } = useFlags();

  const href = csEnablePersonalizedContracts
    ? routes({
        contractVersionId: contractVersion.contractVersionId,
        utilityAccountId: contractVersion.utilityAccountId,
      }).personalizedContract
    : dynamicLanguageParam(
        getTermsUrl({
          internalName: contractVersion.internalName,
          fileUrl: contractVersion.fileUrl,
          id: contractVersion.contractVersionId,
        }),
        user?.languageShortCode
      );

  return (
    <>
      <Link type="inline" href={href}>
        {contractVersion.displayName}
      </Link>
      {getTermLinkJoiner(index, numberOfContracts)}
    </>
  );
};
